module.exports = __webpack_public_path__ + "media/images/front/treatment_support/banner_amazon-gift-card_sp-4ab8e01cf07faf398b42e8e9a2224ceb.png";